import { ensureVideoSubtitlesWithPoll } from "hooks/api/videoSubtitlesClient";
import useProject from "hooks/useProject";
import { useCallback } from "react";
import { VideoSubtitleBlobUrls } from "types/VideoSubtitleDto";

/**
 * Imperative flow: POST ensure, poll GET until READY, then fetch VTT blob URL(s) for `<track>`.
 */
export default function useEnsureVideoSubtitlesBlobUrl() {
  const { projectId } = useProject();

  const ensureSubtitlesBlobUrlsWithPoll = useCallback(
    async (
      videoId: string,
      signal?: AbortSignal,
    ): Promise<VideoSubtitleBlobUrls> => {
      if (!projectId) {
        throw new Error("No project selected.");
      }
      return ensureVideoSubtitlesWithPoll(projectId, videoId, signal);
    },
    [projectId],
  );

  return { ensureSubtitlesBlobUrlsWithPoll };
}
